import { c as _c } from "react-compiler-runtime";
import React from 'react';
import { Skeleton } from '@nike/nike-design-system-components';
import useFetchWebShellProduct from '@nike/shop-apis/web-shell-client/product/use-query';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import useGetFullWishlist from '@nike/shop-apis/buy/wishlists/v2/query-hooks/use-get-full-wishlist';
import ProductAttribute from "../../product-attribute";
import useItemAddedModalStore from "../../../store/item-added-modal/use-store";
var WishlistItemAddedModalProductSize = function WishlistItemAddedModalProductSize() {
  var $ = _c(19);
  var itemId_0 = useItemAddedModalStore(_temp);
  var productCode_0 = useItemAddedModalStore(_temp2);
  var t0;
  if ($[0] !== itemId_0) {
    t0 = {
      select: function select(t1) {
        var _pages$find;
        var pages = t1.pages;
        return pages === null || pages === void 0 || (_pages$find = pages.find(function (item) {
          return item.id === itemId_0;
        })) === null || _pages$find === void 0 ? void 0 : _pages$find.gtin;
      }
    };
    $[0] = itemId_0;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  var _useGetFullWishlist = useGetFullWishlist(t0),
    gtin = _useGetFullWishlist.data,
    isWishlistLoading = _useGetFullWishlist.isLoading;
  var t1;
  if ($[2] !== gtin) {
    t1 = function t1(product) {
      var _sizes$;
      var sizes = (product === null || product === void 0 ? void 0 : product.sizes) || [];
      return {
        matchedSize: sizes.find(function (size) {
          return size.gtin === gtin;
        }),
        isOneSize: sizes.length === 1 && ((_sizes$ = sizes[0]) === null || _sizes$ === void 0 ? void 0 : _sizes$.label) === "ONE SIZE"
      };
    };
    $[2] = gtin;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  var t2;
  if ($[4] !== productCode_0 || $[5] !== t1) {
    t2 = {
      productCode: productCode_0,
      select: t1
    };
    $[4] = productCode_0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  var _useFetchWebShellProd = useFetchWebShellProduct(t2),
    t3 = _useFetchWebShellProd.data,
    isProductLoading = _useFetchWebShellProd.isLoading;
  var t4;
  if ($[7] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  var _t = t4,
    matchedSize = _t.matchedSize,
    isOneSize = _t.isOneSize;
  var t5;
  if ($[9] === Symbol["for"]("react.memo_cache_sentinel")) {
    t5 = {
      stringKey: "one.size",
      primaryValue: "One Size",
      description: "One size label"
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  var oneSizeString = useI18nString(t5);
  var t6;
  if ($[10] === Symbol["for"]("react.memo_cache_sentinel")) {
    t6 = {
      stringKey: "product.sizeLabel",
      primaryValue: "Size",
      description: "Header text representing 'size' of apparel or shoe."
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  var sizeString = useI18nString(t6);
  var isLoading = isWishlistLoading || gtin && isProductLoading;
  if (isLoading) {
    var _t2;
    if ($[11] === Symbol["for"]("react.memo_cache_sentinel")) {
      _t2 = /*#__PURE__*/React.createElement(Skeleton, {
        height: "16px",
        width: "50%",
        style: {
          margin: "6px 0 6px"
        }
      });
      $[11] = _t2;
    } else {
      _t2 = $[11];
    }
    return _t2;
  }
  if (isOneSize) {
    var _t3;
    if ($[12] !== oneSizeString) {
      _t3 = /*#__PURE__*/React.createElement(ProductAttribute, null, oneSizeString);
      $[12] = oneSizeString;
      $[13] = _t3;
    } else {
      _t3 = $[13];
    }
    return _t3;
  }
  var label = matchedSize === null || matchedSize === void 0 ? void 0 : matchedSize.localizedLabel;
  if (!label) {
    return null;
  }
  var sizeTranslation = gtin ? sizeString : null;
  var t7;
  if ($[14] !== label || $[15] !== sizeTranslation) {
    t7 = [sizeTranslation, label].filter(Boolean);
    $[14] = label;
    $[15] = sizeTranslation;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  var sizeText = t7.join(" ");
  var t8;
  if ($[17] !== sizeText) {
    t8 = /*#__PURE__*/React.createElement(ProductAttribute, null, sizeText);
    $[17] = sizeText;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default WishlistItemAddedModalProductSize;
function _temp(t0) {
  var itemId = t0.itemId;
  return itemId;
}
function _temp2(t0) {
  var productCode = t0.productCode;
  return productCode;
}